// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class CitationTrailService {
   alerts: any
   api: ApiService
   availability: AvailabilityService
   fire: any
   labels: any
   scope: any
   types: any
   config: ConfigService
   currentPage?: number

   constructor(api: ApiService, types: any, availability: AvailabilityService, hooksService: HooksService, i18n: any, data: any, alerts: any, config: ConfigService) {

      this.reset = this.reset.bind(this)
      this.getCites = this.getCites.bind(this)
      this.getCitedBy = this.getCitedBy.bind(this)
      this.getCitations = this.getCitations.bind(this)
      this.responseProcessor = this.responseProcessor.bind(this)
      this.responseErrorProcessor = this.responseErrorProcessor.bind(this)
      this.loadMore = this.loadMore.bind(this)
      this.retry = this.retry.bind(this)
      this.query = this.query.bind(this)
      this.sortType = this.sortType.bind(this)
      this.addWaypoint = this.addWaypoint.bind(this)
      this.selectWaypoint = this.selectWaypoint.bind(this)
      this.clearPath = this.clearPath.bind(this)
      this.hasCitedBy = this.hasCitedBy.bind(this)
      this.hasCites = this.hasCites.bind(this)
      this.api = api
      this.types = types
      this.availability = availability
      this.alerts = alerts
      this.config = config
      hooksService.setHooks(this, 'CitationTrailService', ['citationsTriggered', 'citationsReset'])

      // clear path when running a new search
      data.on('new', () => this.reset({clearPath: true}))

      this.scope = {
         sortType: this.sortType,
         path: [],
         nonExactResultCount: this.config.data.search.nonExactResultCount,
         pageSize: this.config.data.results.pageSize
      }

      this.labels = {}
      this.labels[this.types.CITES] = i18n.translations.CITES
      this.labels[this.types.CITED_BY] = i18n.translations.CITED_BY

      this.reset()
   }

   reset(opts = {}) {
      // @ts-expect-error TS(2339) FIXME: Property 'clearPath' does not exist on type '{}'.
      if (opts.clearPath) {
         this.clearPath()
         // @ts-expect-error TS(2339) FIXME: Property 'clearPath' does not exist on type '{}'.
         delete opts.clearPath
      }
      _.extend(this.scope, {
      //This contains the last returned documents
         docs: [],
         // This defines translations and Path view logic cites/citedby also when false hides the tabs
         type: false,
         loading: false,
         loadingError: false,
         count: Infinity,
         pn: 1,
         typeLabel: '',
         sortOrder: 'relevance',
         currentDoc: null,
      }
      , opts
      )
      return this.fire('citationsReset')
   }

   getCites(doc: any) {
      return this.getCitations(doc, this.types.CITES)
   }

   getCitedBy(doc: any) {
      return this.getCitations(doc, this.types.CITED_BY)
   }

   getCitations(doc: any, type: any, pageNum = 1, addWaypoint = true) {
      this.alerts.resetAlert('citationTrailError')

      // Avoid recalls when current doc changed
      if (((this.scope.currentDoc !== null) && (this.scope.currentDoc.id !== doc.id)) || this.scope.loading) { return }

      this.scope.currentDoc = doc
      this.scope.type = type
      this.scope.addWaypoint = addWaypoint
      this.fire('citationsTriggered')

      this.scope.typeLabel = this.labels[type]

      const apiCall = (() => { switch (type) {
         case this.types.CITES: return 'cites'
         case this.types.CITED_BY: return 'citedBy'
      } })()

      this.scope.loading = true
      // @ts-expect-error TS(2538) FIXME: Type 'undefined' cannot be used as an index type.
      return this.api[apiCall](this.query(doc, pageNum))
         .then(this.responseProcessor(doc, pageNum))
         .catch(this.responseErrorProcessor)
         .finally(() => { return this.scope.loading = false })
   }

   responseProcessor(doc: any, pageNum = 1) {
      return (response: any) => {
      // The doc changed by a new search or another one was clicked avoid processing old call.
         if ((this.scope.currentDoc === null) || (this.scope.currentDoc.id !== doc.id)) { return }

         if (response.data?.documents != null) {
            const citations = response.data.documents
            if ((this.scope.pn === 1) && this.scope.addWaypoint) { this.addWaypoint(doc, this.scope.type) }
            this.availability.getRTA(citations)
            _.each(citations, (doc: any, index: number) => {
               //count id for each document on page
               doc.index = index +  this.scope.pageSize * (pageNum - 1) + 1
               // HACK: prevent dupes in result set -- related to match/merge issue during assembly - SUM-95601
               if (_.pluck(this.scope.docs, 'id').indexOf(doc.id) <= -1) { return this.scope.docs.push(doc) }
            })

            this.scope.count = response.data.record_count

         } else {
            if (this.scope.count === Infinity) { return this.scope.count = 0 }
         }
      }
   }

   responseErrorProcessor() {
      return this.scope.loadingError = true
   }

   loadMore(pageNum=1) {
      if (!this.scope.loadingError) { return this.getCitations(this.scope.currentDoc, this.scope.type, pageNum) }
   }

   goToTop() {
      window.scrollTo(0, 0)
   }

   loadPage(pageNum: number) {
      this.scope.docs.forEach((item: any) => item.hidden = true)
      //calculate the first id on page and check if it's already loaded
      if (this.scope.docs.find((item: any) => item.index === (this.scope.pageSize * (pageNum - 1) + 1))) {
         this.loadPageFromCache(pageNum)
      } else {
         this.loadMore(pageNum)
      }
      this.goToTop()
   }

   loadPageFromCache(pageNum: number) {
      let end = 0
      //calculate the first index of range that will be shown from an array of downloaded citations (if only two pages were downloaded the array size will be 20)
      const start = this.scope.docs.findIndex((item: any) => item.index === (pageNum - 1) * this.scope.pageSize + 1)
      
      //if it's a last page, the last index equals count value
      if (Math.ceil(this.scope.count / this.scope.pageSize) === pageNum) {
         end = this.scope.docs.findIndex((item: any) => item.index === this.scope.count)
      } else {
         end = this.scope.docs.findIndex((item: any) => item.index === (pageNum * this.scope.pageSize))
      }

      for (let i = start; i <= end; i++) {
         this.scope.docs[i].hidden = false
      }
   }

   retry() {
      this.scope.loadingError = false
      return this.loadMore()
   }

   query(doc: any, pageNum = 1) {
      const query = {
         q: `ID:${doc.id}`,
         pn: pageNum,
         // request ALL available citation docs -- including docs beyond a library's holdings
         ho: false
      }
      // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      if (this.scope.sortOrder !== 'relevance') { query['sort'] = this.scope.sortOrder }
      return query
   }

   sortType(sortBy: any) {
      this.reset({
         currentDoc: this.scope.currentDoc,
         sortOrder: sortBy,
         type: this.scope.type
      })
      //TODO check pageNum
      return this.getCitations(this.scope.currentDoc, this.scope.type, 1, false)
   }

   addWaypoint(doc: any, type: any) {
      if (type == null) { throw new Error('Waypoint requires a "type"') }
      const pathDocument = {
         type,
         typeLabel: this.labels[type],
         title: doc.title,
         id: doc.id
      }
      return this.scope.path.unshift(pathDocument)
   }

   selectWaypoint(index: any) {
      const pathDoc = this.scope.path[index]
      this.clearPath(index)
      this.reset()
      //TODO check pageNum
      return this.getCitations(pathDoc, pathDoc.type, 1, false)
   }

   clearPath(index = null) {
      if (index != null) {
         return this.scope.path = this.scope.path.slice(index)
      } else {
         return this.scope.path = []
      }
   }

   hasCitedBy(doc: any) { 
      return doc.cited_by_id?.length || doc.cited_by_doi?.length || doc.cited_by_isbn?.length
   }

   hasCites(doc: any) {
      return doc.cites_id?.length || doc.cites_doi?.length || doc.cites_isbn?.length
   }
}

CitationTrailService.$inject = ['apiService', '$citationTrailTypes', 'availabilityService', 'hooksService', 'translationService', 'dataService', 'alertService', 'configService']

angular.module('summonApp.services')
   .service('citationTrailService', CitationTrailService)
